import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import CompanyLogo from './components/companyLogo.jsx';
import ConnString from './ConnString.js';
import {
  Alert,
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Link,
  Paper,
  TextField,
  Typography,
} from '@mui/material';

const Connstring2 = ConnString.connstring;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [status, setStatus] = useState('info');
  const [message, setMessage] = useState('Welcome back! Please sign in to continue.');
  const [open, setOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [showSelection, setShowSelection] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userFullName, setuserFullName] = useState('');
  const [userID, setuserID] = useState('');
  const [compID, setcompID] = useState('');
  const [compName, setcompName] = useState('');
  const [compLogo, setcompLogo] = useState('');
  const [SqlDBName, setsSqlDBName] = useState('');
  const [SQLdbUSerID, setsSQLdbUSerID] = useState('');
  const [SQLdbPW, setsSQLdbPW] = useState('');
  const [SQLdbDataSource, setsSQLdbDataSource] = useState('');
  const [dbPort, setsdbPort] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    const rememberedPassword = localStorage.getItem('rememberedPassword');

    if (rememberedEmail) {
      setEmail(rememberedEmail);
      setRememberMe(true);
    }
    if (rememberedPassword) {
      setPassword(rememberedPassword);
    }
  }, []);

  const getLogoURL = (rawUrl) => {
    const value = String(rawUrl || '').trim();
    if (!value) return '';

    if (value.includes('drive.google.com')) {
      const existingThumbnail = value.match(/[?&]id=([^&]+)/);
      if (value.includes('/thumbnail') && existingThumbnail?.[1]) {
        return `https://drive.google.com/thumbnail?id=${existingThumbnail[1]}&sz=w1000`;
      }

      const directMatch = value.match(/[?&]id=([^&]+)/);
      if (directMatch?.[1]) {
        return `https://drive.google.com/thumbnail?id=${directMatch[1]}&sz=w1000`;
      }

      const pathMatch = value.match(/\/d\/([^/]+)/);
      if (pathMatch?.[1]) {
        return `https://drive.google.com/thumbnail?id=${pathMatch[1]}&sz=w1000`;
      }
    }

    // Some records store only the Drive file id.
    if (/^[A-Za-z0-9_-]{20,}$/.test(value)) {
      return `https://drive.google.com/thumbnail?id=${value}&sz=w1000`;
    }

    return value;
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(`${Connstring2}/api/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      const result = await response.json();

      if (result.success) {
        sessionStorage.clear();
        navigate('/');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const finalizeCompanySelection = async (companyOption) => {
    const option = companyOption || selectedOption;

    if (!option) {
      setStatus('error');
      setMessage('Please choose a company to continue.');
      return;
    }

    const resolvedCompName = option.Company || option.CompanyName || '';
    const resolvedCompID = option.CompID || '';
    const resolvedSqlDBName = option.SqlDBName || '';
    const resolvedSQLdbUSerID = option.SQLdbUSerID || '';
    const resolvedSQLdbPW = option.SQLdbPW || '';
    const resolvedSQLdbDataSource = option.SQLdbDataSource || '';
    const resolvedDbPort = option.dbPort || '';
    const resolvedUserFullName = option.FullName || '';
    const resolvedUserID = option.UserName || '';
    const resolvedCompLogo = getLogoURL(option.compLogo || option.Logo || '');

    setSelectedOption(option);
    setcompName(resolvedCompName);
    setcompID(resolvedCompID);
    setsSqlDBName(resolvedSqlDBName);
    setsSQLdbUSerID(resolvedSQLdbUSerID);
    setsSQLdbPW(resolvedSQLdbPW);
    setsSQLdbDataSource(resolvedSQLdbDataSource);
    setsdbPort(resolvedDbPort);
    setuserFullName(resolvedUserFullName);
    setuserID(resolvedUserID);
    setcompLogo(resolvedCompLogo);

    setStatus('info');
    setMessage('Finalizing login...');
    setOpen(true);

    try {
      const response = await fetch(`${Connstring2}/api/Companylogin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          email,
          xusername: resolvedUserID,
          password,
          compcode: resolvedCompID,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const finalCompLogo = getLogoURL(data?.compLogo || option.compLogo || option.Logo || resolvedCompLogo);
        sessionStorage.setItem('selectedCompany', option.CompanyName || option.Company);
        sessionStorage.setItem('isLoggedIn', 'true');
        sessionStorage.setItem('userEmail', email);
        sessionStorage.setItem('userPassword', password);
        sessionStorage.setItem('userFullName', resolvedUserFullName);
        sessionStorage.setItem('userID', resolvedUserID);
        sessionStorage.setItem('compID', resolvedCompID);
        sessionStorage.setItem('compName', resolvedCompName);
        sessionStorage.setItem('SqlDBName', resolvedSqlDBName);
        sessionStorage.setItem('SQLdbUSerID', resolvedSQLdbUSerID);
        sessionStorage.setItem('SQLdbPW', resolvedSQLdbPW);
        sessionStorage.setItem('SQLdbDataSource', resolvedSQLdbDataSource);
        sessionStorage.setItem('dbPort', resolvedDbPort);
        sessionStorage.setItem('compLogo', finalCompLogo);
        setcompLogo(finalCompLogo);
        sessionStorage.setItem(
          'compConnstring',
          `Data Source=${resolvedSQLdbDataSource};Initial Catalog=${resolvedSqlDBName};User id=${resolvedSQLdbUSerID};Password=${resolvedSQLdbPW}`
        );
        if (rememberMe) {
          localStorage.setItem('rememberedEmail', email);
          localStorage.setItem('rememberedPassword', password);
        } else {
          localStorage.removeItem('rememberedEmail');
          localStorage.removeItem('rememberedPassword');
        }

 
        navigate('/App');
      } else {
        setStatus('error');
        setMessage(data?.message || 'Failed to complete company selection.');
      }
    } catch (err) {
      console.error('Error details:', err);
      setStatus('error');
      setMessage('Unable to complete login. Please try again later.');
    } finally {
      setOpen(false);
    }
  };

  const handleSelectionSubmit = async (event) => {
    event.preventDefault();
    await finalizeCompanySelection();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('info');
    setMessage('Authenticating...');
    setOpen(true);

    if (!email || !password) {
      setStatus('error');
      setMessage('Please enter both email and password.');
      setOpen(false);
      return;
    }

    try {
      const response = await fetch(`${Connstring2}/api/login-with-options`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const opts = Array.isArray(data.options) ? data.options : [];
        if (opts.length === 1) {
          setStatus('info');
          setMessage('One company found. Continuing...');
          await finalizeCompanySelection(opts[0]);
        } else if (opts.length > 1) {
          setDropdownOptions(opts);
          setShowSelection(true);
          setStatus('success');
          setMessage('Login successful. Select your company to continue.');
        } else {
          setStatus('error');
          setMessage('No company access found for this user.');
        }
      } else {
        setStatus('error');
        setMessage(data?.message || 'Login failed. Check your email and password.');
      }
    } catch (err) {
      console.error('Error details:', err);
      setStatus('error');
      setMessage('An unexpected error occurred. Please try again.');
    } finally {
      setOpen(false);
    }
  };

  return (
    <Box sx={styles.pageWrapper}>
      <Box sx={styles.visualPanel}>
        <Box sx={styles.brandContainer}>
          <Box sx={styles.logoWrapper}>
            <CompanyLogo
              key={compLogo || 'default-login-logo'}
              imglink={compLogo || 'https://drive.google.com/file/d/1UQqATyqUpSa5YoomiVq-kM_aIaIgS062/view?usp=sharing'}
            />
          </Box>
          <Typography variant="h3" fontWeight={700} sx={{ mt: 3, color: '#FFF' }}>
            Business Journal
          </Typography>
          <Typography variant="subtitle1" color="rgba(255,255,255,0.84)" sx={{ mt: 1, maxWidth: 360 }}>
            Securely manage your company data, monitoring, reports, and transactions from a modern dashboard.
          </Typography>
        </Box>
      </Box>

      <Paper elevation={16} sx={styles.formPanel}>
        <Box sx={styles.formHeader}>
          <Typography variant="h5" fontWeight={700}>
            Sign in to your account
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Enter your credentials to continue to the business dashboard.
          </Typography>
        </Box>

        {message && (
          <Alert severity={status === 'error' ? 'error' : status} sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}

        {!showSelection ? (
          <Box component="form" onSubmit={handleSubmit} sx={styles.form} noValidate>
            <TextField
              label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              fullWidth
              autoComplete="username"
              autoFocus
              sx={{ backgroundColor: '#f9fbff' }}
            />
            <TextField
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              required
              fullWidth
              autoComplete="current-password"
              sx={{ backgroundColor: '#f9fbff' }}
            />
            <Box sx={styles.row}>
              <FormControlLabel
                control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                label="Remember me"
              />
              <Link component={RouterLink} to="/forgot-password" underline="hover">
                Forgot password?
              </Link>
            </Box>
            <Button type="submit" variant="contained" size="large" fullWidth disabled={open}>
              {open ? 'Signing in...' : 'Login'}
            </Button>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSelectionSubmit} sx={styles.form} noValidate>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
              Choose your company
            </Typography>
            <Autocomplete
              id="company-selector"
              options={dropdownOptions}
              getOptionLabel={(option) => option.CompanyName || option.Company || ''}
              onChange={(event, newValue) => {
                setSelectedOption(newValue);
                if (!newValue) return;
                setcompName(newValue.Company || newValue.CompanyName || '');
                setcompID(newValue.CompID || '');
                setsSqlDBName(newValue.SqlDBName || '');
                setsSQLdbUSerID(newValue.SQLdbUSerID || '');
                setsSQLdbPW(newValue.SQLdbPW || '');
                setsSQLdbDataSource(newValue.SQLdbDataSource || '');
                setsdbPort(newValue.dbPort || '');
                setuserFullName(newValue.FullName || '');
                setuserID(newValue.UserName || '');
                setcompLogo(getLogoURL(newValue.compLogo || newValue.Logo || ''));
           
              }}
              renderInput={(params) => <TextField {...params} label="Company" required fullWidth sx={{ backgroundColor: '#f9fbff' }} />}
              fullWidth
            />
            <Box sx={styles.buttonRow}>
              <Button variant="outlined" onClick={handleLogout} disabled={open}>
                Back
              </Button>
              <Button variant="contained" onClick={handleSelectionSubmit} disabled={open || !selectedOption}>
                {open ? 'Continuing...' : 'Continue'}
              </Button>
            </Box>
          </Box>
        )}

        {!showSelection && (
          <Typography variant="body2" align="center" sx={{ mt: 3, color: 'text.secondary' }}>
            Don't have an account?{' '}
            <Link href="/ERP/register.html" underline="hover">
              Create one
            </Link>
          </Typography>
        )}
      </Paper>

      <Backdrop sx={styles.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

const styles = {
  pageWrapper: {
    width: '100%',
    maxWidth: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    justifyContent: 'center',
    mx: 'auto',
    px: { xs: 2, md: 2 },
    py: { xs: 2, md: 3 },
    gap: { xs: 3, md: 4 },
    background: 'linear-gradient(135deg, #1f3d7a 0%, #0b2049 100%)',
  },
  visualPanel: {
    flex: '1 1 480px',
    width: '100%',
    maxWidth: 560,
    height: { xs: 'auto', md: '100%' },
    minHeight: 520,
    borderRadius: 4,
    background: 'linear-gradient(180deg, rgba(83, 116, 233, 0.96), rgba(27, 44, 105, 0.96))',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: { xs: 3, md: 4 },
    boxShadow: '0 30px 60px rgba(0,0,0,0.25)',
  },
  brandContainer: {
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  formPanel: {
    flex: '1 1 420px',
    width: '100%',
    maxWidth: 560,
    minWidth: 340,
    height: { xs: 'auto', md: '100%' },
    minHeight: 520,
    borderRadius: 4,
    p: { xs: 3, md: 4 },
    backgroundColor: '#f8fbff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: '0 30px 60px rgba(15,23,42,0.16)',
  },
  formHeader: {
    mb: 3,
  },
  form: {
    display: 'grid',
    gap: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
  },
  buttonRow: {
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  backdrop: {
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
  },
};

export default Login;
